import { BaseGetRequest } from './core/baseGetRequest';
import { Booking, BookingDynamicType } from 'acscp/api/models/booking';
import { Authentication } from './core/baseRequest';

export class BookingRequest extends BaseGetRequest<Booking> {
    constructor(bookingId: string) {
        super(`bookings/${bookingId}`, {}, BookingDynamicType, Authentication.SharingToken, 'v2');
    }
}
